import { useState, useEffect } from 'react'
import { Container } from "./styles"
import Button from "../../../../components/Button"
import { api } from "../../../../services/api"
import { Link, useLocation, useParams } from "react-router-dom"

const ShowRetailer = () => {

    const location = useLocation()
    const {id} = useParams()

	const [retailer, setRetailer] = useState(location.state?.retailer || {})

    useEffect(() => {
		api.get(`retailers/show/${id}`)
		.then((response) => {
		setRetailer(response.data)	
		})
    }, [id, location])


    return (
    <Container>
		<div className="about">
        	<h1>{retailer?.name}</h1>
			<p><span>Email: </span>{retailer?.email}</p>
			<p><span>CPF: </span>{retailer?.cpf}</p>
			<p><span>Endereço: </span>{retailer?.address}</p>
        	<p><span>CEP: </span>{retailer?.cep}</p>
			<p><span>Telefone: </span>{retailer?.phone}</p>
			<p><span>Conta Bancária: </span>{retailer?.bank_account}</p>
        </div>
		<div className="buttons">
			<Link to="/manager/retailers"><Button className="button">Voltar</Button></Link>
		</div>
        </Container>
    )
}

export default ShowRetailer
